
    <form (ngSubmit)="saveFirstTab(false)" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="code" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="description" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.discountType', md: '6' }">
            <p-dropdown formControlName="discount_type_id" [options]="discountTypes" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.discountAmt', md: '6' }">
            <input type="number" min="0" pInputText formControlName="discount_amt" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.couponType', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="coupon_type"
              maxlength="1"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.notes', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="notes" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.barCodeType', md: '6' }">
            <p-dropdown formControlName="barcode_type_pid" [options]="barCodes" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.barCode', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="barcode"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.cluster', md: '4' }">
            <p-dropdown formControlName="cluster_id" [options]="clusters" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: '', md: '1' }"></div>
          <div [kv-form-element]="{ label: 'promotion.daysFromEmission', md: '2' }">
            <input type="number" min="0" pInputText formControlName="days_from_emission" />
          </div>
          <div [kv-form-element]="{ label: '', md: '1' }"></div>
          <div [kv-form-element]="{ label: 'promotion.typeMessage', md: '4' }">
            <p-dropdown formControlName="type_message_id" [options]="messagesTypes" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.stretchValue', md: '6' }">
            <input type="number" min="0" pInputText formControlName="stretch_value" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.thresholdValue', md: '6' }">
            <input type="number" min="0" pInputText formControlName="threshold_value" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.template', md: '4' }">
            <p-dropdown formControlName="fe_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.redemptionTemplate', md: '4' }">
            <p-dropdown formControlName="redemption_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.emissionTemplate', md: '4' }">
            <p-dropdown formControlName="emission_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div class="ui-g-12">
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.fidelity', md: '2' }">
              <p-inputSwitch formControlName="flg_fidelity"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.cardHolder', md: '2' }">
              <p-inputSwitch formControlName="flg_card_holder"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.openCoupon', md: '2' }">
              <p-inputSwitch formControlName="flg_open_coupon"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          label="{{'common.save' | translate}}">
        </button>
      </div>
      <div class="text-right">
        <button 
          *ngIf="shortInsert"
          pButton type="button"
          class="k-generic-btn"
          icon="fa fa-angle-left"
          iconPos="left"
          label="{{ 'promotion.saveAndBackToDetail' | translate }}"
          (click)="saveFirstTab(true)">
        </button>
      </div>
    </form>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/tab/message/tabMessage.component.ts.TabMessageComponent.html